import { Container } from '../../components/container/container';
import { Page } from '../../components/page-layout/page';
import { createFileRoute } from '../../utils/route-factory';

function E911Dashboard() {
  return (
    <Page
      title='E911 Dashboard'
      breadcrumbs={[
        {
          label: 'Global Settings',
        },
        {
          label: 'E911 Dashboard',
        },
      ]}
    >
      <Container>TODO</Container>
    </Page>
  );
}

export const Route = createFileRoute({
  path: '/global-settings/e911-dashboard',
  component: E911Dashboard,
  type: 'auth',
});
